module.exports = __webpack_public_path__ + "img/sumdes-page_900.2f2cdcf8.png";